<template>
	<div>
		<filtros :filter_data="filter_data" @filtrar="filtrar" />

		<table class="table table-striped table-sm">
    		<thead align="center">
    			<th @click="orderBy('id')"       >ID	<font-awesome-icon v-if="direction.by == 'id'"       :icon="order_icon" size="xs" /></th>
    			<th @click="orderBy('name')"     >Nome	<font-awesome-icon v-if="direction.by == 'name'"     :icon="order_icon" size="xs" /></th>
    			<th @click="orderBy('username')" >Login	<font-awesome-icon v-if="direction.by == 'username'" :icon="order_icon" size="xs" /></th>
    			<th @click="orderBy('type')"     >Tipo	<font-awesome-icon v-if="direction.by == 'type'"     :icon="order_icon" size="xs" /></th>
    			<th></th>
    		</thead>
			
			<transition mode="out-in" name="leftIn">
	    		<tbody v-if="users" align="center">
	    			<tr v-for="(user, index) in users.result.data" :key="index">
						<td>{{ user.id }}</td>
						<td>{{ user.name }}</td>
						<td>{{ user.username }}</td>
						<td>{{ get_user_fold(user.type) }}</td>
						<td><font-awesome-icon icon="eye" class="info pointer" @click="view(user)" /></td>
					</tr>

	    		</tbody>
	    		<div v-else><Loading/></div>
    		</transition>
    	</table>

    	<controls :data="constrol_data" @refresh="navigate"  @alert="show_alert" />
    	<viewUser :user="modal_user" :password="{}" :action="action"  @alert="show_alert" />
	</div>
</template>

<script>
	import api      from "@/mixins/api.js"
	import replace  from "@/mixins/replace.js"
	import filtros  from "@/components/Tools/Filtro.vue"
	import controls from "@/components/Tools/Table_Control.vue"
	import viewUser from "@/components/Modal/Cadastro/Usuario.vue"

	export default {
		name: "Usuarios",
		props: ["table", "method"],
		mixins: [api, replace],
		components: { 
			controls, 
			viewUser, 
			filtros 
		},

		data: () => { 
			return {
				modal_user: {},
				action: null,
				users: null,
				constrol_data: {},

				direction: { 
					order: "asc", 
					by: "id" 
				},

				pagination: "10?",
				string_filter: "",

				filter_data: [
					{ 
						name: "id",         
						label: "ID",        
						type: "text",   
						data_get: ""
					},
					{ 
						name: "email",      
						label: "Email",     
						type: "text",   
						data_get: ""
					},
					{ 
						name: "name",       
						label: "Nome",      
						type: "text",   
						data_get: ""
					},
					{ 
						name: "matricula",  
						label: "Matrícula", 
						type: "text",   
						data_get: ""
					},
					{ 
						name: "unidade_id", 
						label: "Unidade",   
						type: "select", 
						data_get: "Unidade"
					},
				]
			}
		},

		created() {
			this.$emit('update:pdf', true);
			this.$emit('update:pdf_title', 'usuários');
			this.$emit('update:pdf_external', false);
			this.$emit('update:pdf_datatable', 'User');
			this.$emit('update:pdf_header', ["ID", "NOME", "EMAIL", "LOGIN", "TIPO"] );
			this.$emit('update:pdf_body', ["id", "name", "email", "username", "type"] );
			this.get_data();
		},

		computed: {
			ordenation() {
				return `order=${this.direction.order}&by=${this.direction.by}`;
			},

			order_icon() {
				return ( this.direction.order == "asc" ) ? "arrow-up" : "arrow-down";
			}
		},

		methods: {
			orderBy(payload) {
				if ( payload == this.direction.by ) {
					this.direction.order = ( this.direction.order == 'desc' ) ? 'asc' : 'desc';
				}else{
					this.direction.by = payload;
				}

				this.get_data();
			},

			filtrar(payload) {
				this.string_filter = payload;
				this.$emit('update:pdf_string_filter', payload);
				this.get_data();
			},

			is_super_adm() {
				if(this.$store.state.user.type !== 3){
					return "&unidade_id="+this.$store.state.user.unidade_id;
				}else {
					return "";
				}
				
			},

			async get_data() {
				this.users = null;
				var unidade_filtro = this.is_super_adm();
				this.users = await this.GET("User", `Paginate/${this.pagination}${this.ordenation}${this.string_filter}${unidade_filtro}`);

				this.constrol_data = {
					current_page: this.users.result.current_page,
					last_page:    this.users.result.last_page,
					per_page:     this.users.result.per_page,
					total:        this.users.result.total,
				}
			},

			navigate(payload) {
				this.pagination = payload;
				this.get_data();
			},

			view(user) { 
				this.modal_user = user;
				this.action = "view";
				$("#modal-cadastro-user").modal();
			},

			add() { 
				this.modal_user = {};
				this.action = "add";
				$("#modal-cadastro-user").modal();
			},

			show_alert(payload) {
				$("#modal-cadastro-user").modal('hide');
				this.get_data();

				this.$emit('alert', payload);
			},
		},
	};
</script>

<style>
	
</style>